import { Translate } from '@chipinside/translate'
import { Box, Chip, Typography } from '@mui/material'

import { GroupTitleProps } from '#/components/AdvancedSearch/types'
import { ItemBadge } from '#/components/AdvancedSearch/View/CategoryBadge'

const linkSx = {
  color: 'primary.main',
  cursor: 'pointer',
  fontWeight: 600,
  ml: 'auto',
  mr: 2,
}

/** Cabeçalho de cada grupo de resultado */
export function GroupTitle({
  color,
  count,
  isCapped,
  label,
  onClear,
  onClearFilter,
  onViewAll,
  shownCount,
}: GroupTitleProps) {
  const show = isCapped ? `${shownCount} / ${count}` : count

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', gap: 1, mb: 0.5, mt: 2 }}>
      <ItemBadge color={color} />
      <Typography
        variant="overline"
        sx={{ color: 'text.secondary', fontWeight: 700, letterSpacing: 0.5, lineHeight: 'normal' }}
      >
        {label}
      </Typography>
      <Chip label={show} size="small" />
      {onViewAll && (
        <Typography onClick={onViewAll} variant="body2" sx={linkSx}>
          {Translate({ messageKey: 'view_all_count', params: { count } })}
        </Typography>
      )}
      {onClearFilter && (
        <Typography onClick={onClearFilter} variant="body2" sx={linkSx}>
          {Translate({ messageKey: 'search_back_to_all' })}
        </Typography>
      )}
      {onClear && (
        <Typography onClick={onClear} variant="body2" sx={linkSx}>
          {Translate({ messageKey: 'clear' })}
        </Typography>
      )}
    </Box>
  )
}
